import React, { useState } from 'react';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';
import useNewCareerPositionContext from 'contexts/career-position.context';
import Select from 'components/base/select';
import {
  departmentsInFc,
  experienceLevel,
  locationsInFc,
  workModeInFC
} from 'pages/create-career-position/create-job-details/utils';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router-dom';
import SingleBottomNav from 'components/base/single-bottom-nav';

type Props = {
  onEditComplete: () => void;
};
const EditJobDetails = ({ onEditComplete }: Props) => {
  const { setCreateJobPositionForm, createJobPositionForm } = useNewCareerPositionContext();

  const [loading, setLoading] = useState(false);

  const { job_id } = useParams();

  const handleUpdateJobPosting = async () => {
    setLoading(true);

    try {
      await apiService.put(`careers/jobs/${job_id}`, {
        data: {
          role: createJobPositionForm.jobTitle,
          department: createJobPositionForm.department,
          work_mode: createJobPositionForm.workMode,
          experience_level: createJobPositionForm.experience,
          locations: [createJobPositionForm.location],
          status: createJobPositionForm.status
        }
      });

      onEditComplete();
      toast(<ToastMessage type='success' message={`Job updated successfully`} />);
    } catch {
      toast(<ToastMessage type='error' message={`There was a problem creating position `} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='space-y-4'>
      <Input
        type='text'
        label='Job title'
        placeholder='Enter job title'
        className='w-full mt-4'
        inputClass='px-4 py-3'
        value={createJobPositionForm.jobTitle}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, jobTitle: e.target.value })
        }
      />

      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Department/Team</p>
        <Select
          placeholder='Select department'
          value={createJobPositionForm.department}
          options={departmentsInFc.map((dept) => ({ value: dept, text: dept }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, department: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Work mode</p>
        <Select
          placeholder='Select work mode'
          value={createJobPositionForm.workMode}
          options={workModeInFC.map((mode) => ({ value: mode, text: mode }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, workMode: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Experience level</p>
        <Select
          placeholder='Select experience level'
          value={createJobPositionForm.experience}
          options={experienceLevel.map((mode) => ({ value: mode, text: mode }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, experience: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Location</p>
        <Select
          placeholder='Select location'
          value={createJobPositionForm.location}
          options={locationsInFc.map((location) => ({ value: location, text: location }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, location: v })}
        />
      </div>

      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateJobPosting}
        backBtndisabled
        btnDisabled={loading}
      />
    </div>
  );
};

export default EditJobDetails;
